import React from 'react'
import PropTypes from 'prop-types'


const Content = (props, context) => {
    let {formatMessage} = context
    return (
        <div><p className="text-center h1-55">Blimey!</p><p className="text-center h1-21">{formatMessage('pageNotFound')}</p></div>
    )
}
Content.contextTypes = {formatMessage: PropTypes.any}


export default Content


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/NotFound/Content.js